import { render, staticRenderFns } from "./preview-table.vue?vue&type=template&id=140f1f92&scoped=true"
import script from "./preview-table.vue?vue&type=script&lang=js"
export * from "./preview-table.vue?vue&type=script&lang=js"
import style0 from "./preview-table.vue?vue&type=style&index=0&id=140f1f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f1f92",
  null
  
)

export default component.exports